import { mergeStyles} from "@fluentui/react/";

export const container = mergeStyles({
    display: "flex",
    flexDirection: "column"
})

